import React, { useState } from 'react';
import { Table } from 'react-bootstrap';

import DropdownSearch from '../DropdownSearch';

import './CustomTable.sass';

function HeaderCell({
  title,
  setSorting = null,
  active = false,
  ascending = null,
  keyValue,
  searchable = false,
  className = '',
}) {
  const [show, setShow] = useState(false);
  return (
    <th
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      className={className}
    >
      <div className={`header-cell header-cell-${keyValue}`}>
        <span
          style={{
            fontWeight: active ? 700 : 400,
          }}
          onClick={() => setSorting && setSorting(keyValue)}
        >
          <span>{title}</span>
          {setSorting && (
            <span style={{ marginLeft: 'auto' }}>
              {ascending ? 'asc' : 'desc'}
            </span>
          )}
        </span>
        {searchable && (
          <span>
            <DropdownSearch keyValue={keyValue} show={show} />
          </span>
        )}
      </div>
    </th>
  );
}
function TableHead({ columns = [], ...props }) {
  return (
    <thead>
      <tr>
        {columns.map(({ key, title, ...rest }) => (
          <HeaderCell
            key={key}
            keyValue={key}
            title={title}
            active={key === rest.criteria || !rest.setSorting}
            {...rest}
            {...props}
          />
        ))}
      </tr>
    </thead>
  );
}

function TableRow({ columns = [], state = {} }) {
  return (
    <tr>
      {columns.map(({ key, className = '' }) => (
        <td key={key} className={className}>
          {state[key]}
        </td>
      ))}
    </tr>
  );
}

function TableBody({ columns = [], data = [] }) {
  return (
    <tbody>
      {data.map((d) => (
        <TableRow key={d.id} columns={columns} state={d} />
      ))}
    </tbody>
  );
}

function CustomTable({
  columns = [],
  data = [],
  setSorting = null,
  criteria = null,
  ascending = null,
  searchable,
  ...props
}) {
  if (!columns.length) {
    return null;
  }
  return (
    <Table {...props}>
      <TableHead
        columns={columns}
        setSorting={setSorting}
        criteria={criteria}
        ascending={ascending}
        searchable={searchable}
      />
      <TableBody columns={columns} data={data} />
    </Table>
  );
}

export default CustomTable;
